(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     Toggle: Meals promo banner open/closed
     -------------------------------------------------------------------------- */

  function initBannerToggle() {
    var toggle = document.querySelector('[data-upsell-toggle]');
    if (!toggle) return;

    var body = document.querySelector('[data-upsell-body]');
    if (!body) return;

    var banner = document.querySelector('[data-cart-upsell-banner]');
    toggle.addEventListener('click', function () {
      var isCollapsed = body.classList.toggle('is-collapsed');
      if (banner) banner.classList.toggle('is-open', !isCollapsed);
      toggle.setAttribute('aria-expanded', String(!isCollapsed));
    });
  }

  /* --------------------------------------------------------------------------
     Add to cart via upsell buttons
     -------------------------------------------------------------------------- */

  function initAddToCart() {
    var buttons = document.querySelectorAll('[data-upsell-add-variant]');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled || btn.classList.contains('is-loading')) return;
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        btn.classList.add('is-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed: ' + response.status);
            return response.json();
          })
          .then(function () {
            refreshCart();
          })
          .catch(function (err) {
            console.error('[cart-upsell]', err);
            btn.classList.remove('is-loading');
          });
      });
    });
  }

  /* --------------------------------------------------------------------------
     Refresh the cart drawer after adding an item
     --------------------------------------------------------------------------
     Broadcast theme listens for these events:
       - 'theme:cart:refresh' → triggers getCart() which fetches section HTML
       - 'theme:product:add'  → triggers productAddCallback
     We dispatch both, then fall back to page reload if needed.
     -------------------------------------------------------------------------- */

  function refreshCart() {
    // Broadcast's cart refresh event
    document.dispatchEvent(new CustomEvent('theme:cart:refresh'));

    // Also signal that a product was added (opens drawer + refreshes)
    document.dispatchEvent(new CustomEvent('theme:product:add', {
      detail: { button: null },
      bubbles: false
    }));

    // Fallback: if the cart count hasn't changed after 2s, reload the page
    var sentinel = document.querySelector('[data-cart-count]');
    var countBefore = sentinel ? sentinel.textContent.trim() : null;

    setTimeout(function () {
      var countAfter = sentinel ? sentinel.textContent.trim() : null;
      if (countBefore !== null && countBefore === countAfter) {
        window.location.reload();
      }
    }, 2000);
  }

  /* --------------------------------------------------------------------------
     Initialise on DOM ready
     -------------------------------------------------------------------------- */

  function init() {
    initBannerToggle();
    initAddToCart();
  }

  /* Expose globally so refreshUpsells can re-init after DOM swap */
  window.initCartUpsell = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
